import Modal from '../common/modal'
import Button from '@mui/material/Button'
import { Stack, Box, Typography, TableRow, TableCell, Radio, useTheme } from '@mui/material'
import { Modal as MuiModal } from '@mui/material'
import React, { useRef, useState } from 'react'
import QRCode from 'react-qr-code'
import { useEffect } from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import '../../css/bookingprint.scss'
import LineInputV2 from './lineinputV2'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'
import { formatDate2, getTrackingUrl, validateAadhar, validateDL, validatePan } from './helper'
import { getLengthWithIDType, getNum, singleInputKeyDown } from './helper'
import { focusElemnt, getFilterWithIdType, getGSTNAddress } from './helper'
import { handleIdSaveButton, handleUploadButton } from './bookingHelper'
import DropDown from './dropDown'
import { noImageUrl } from './constants'
import DropDownOA from './dropDownOA'
import * as iid from './bookingElementId'
import Lineinput from './lineinput'
import { deliveryDataAtom, deliveryIdFileAtom } from './jotaiState/deliveryStateAtoms'
import { useAtom } from 'jotai'
import { alertAtom, modalAtom } from './jotaiState/globalStateAtoms'
import { useSelector } from 'react-redux'
import { GOLINK, SS_CARRIERS } from '../../helper/companyIdhardcode'
import { useTranslation } from '../../i18n/I18nProvider'
import {
  decodeTable,
  filterItemsHiddenByTables,
  filterQrLogoHiddenByTables,
  isTableToken,
  resolveCellDisplayValue,
} from './ticketTableFormat'
import { idProofListAtom, senderIdDetailsSavedAtom, senderIdFileAtom, senderIdNumberAtom, senderIdTypeAtom } from './jotaiState/bookingStateAtoms'

export const SuccessPopUp = (data) => {
  const buttonRef1 = useRef(null)
  const buttonRef2 = useRef(null)
  const { translations } = useTranslation()
  const cs = translations.common
  useEffect(() => {
    if (data.data.yesDefault) {
      buttonRef1.current.focus()
    } else {
      buttonRef2.current.focus()
    }
  })
  return (
    <Modal headTxt={data.data.headTxt ? data.data.headTxt : cs.confirm} width={'25%'} updateModal={data.updateModal}>
      <Stack>
        <Box style={{ margin: '20px', fontSize: '19px' }}>
          <Typography sx={{ fontSize: data.data?.fontSize ? data.data?.fontSize : '13px' }}>{data.data?.successMessage}</Typography>
          <Typography>{data.data?.otherMessage}</Typography>
        </Box>
      </Stack>
      <Stack>
        <Box component="div" className="modal-btn-grp confirm-poup-grp">
          <Button
            ref={buttonRef1}
            id={data.data?.buttonId1}
            style={{
              background: 'rgb(255, 0, 0)',
              color: 'white',
              padding: '7px 20px',
              fontSize: '12px'
            }}
            onClick={() => data.data?.yesAction()}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef2)}
          >
            {cs.yes}
          </Button>
          <Button
            ref={buttonRef2}
            id={data.data?.buttonId2}
            style={{ fontSize: '12px' }}
            className="select-lr-btn"
            variant="outlined"
            color="error"
            onClick={() => data.data?.noAction()}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
          >
            {cs.no}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
export const SuccessPopUp1 = (data) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const buttonRef1 = useRef(null)
  useEffect(() => {
    buttonRef1.current.focus()
  })
  return (
    <Modal headTxt={cs.confirm} width={'25%'} updateModal={data.updateModal} ononCloseCallback={data.data?.yesAction}>
      <Stack>
        <Box style={{ margin: '20px', fontSize: '19px' }}>
          <Typography>{data.data?.successMessage}</Typography>
          <Typography>{data.data?.otherMessage}</Typography>
        </Box>
      </Stack>
      <Stack>
        <Box component="div" className="modal-btn-grp confirm-poup-grp">
          <Button
            ref={buttonRef1}
            id={data.data?.buttonId1}
            className="select-lr-btn"
            style={{
              background: 'rgb(255, 0, 0)',
              color: 'white',
              padding: '7px 20px',
            }}
            onClick={() => data.data?.yesAction()}
          // onKeyDown = {(e)=>successPopUpKeyDown(e,buttonRef2)}
          >
            {cs.ok}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
export const StickerPrintPreview = (data) => {
  const { TicketDimension, TicketFormat, TicketData, QRandLogoFormat, qrList, FormatFont } = {
    ...data,
  }
  const visibleTicketFormat = filterItemsHiddenByTables(TicketFormat)
  const visibleQrAndLogoFormat = filterQrLogoHiddenByTables(QRandLogoFormat, TicketFormat)
  const { LogoURL } = { ...TicketData }
  const { range } = data
  const [from, to] = range
  const qrListToPrint = qrList.slice(from - 1, to)
  const handleClose = () => {
    data.onClose && data.onClose()
  }
  useEffect(() => {
    const handlePrint = () => {
      const divContents = document.getElementById('stickersPrintBox')?.innerHTML
      if (!divContents) return

      const iframe = document.createElement('iframe')
      iframe.style.position = 'fixed'
      iframe.style.right = '0'
      iframe.style.bottom = '0'
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.style.border = '0'
      document.body.appendChild(iframe)

      const doc = iframe.contentDocument || iframe.contentWindow.document
      doc.open()
      doc.write(`
        <html>
          <head>
            <style>
              /* Copy any required print styles here */
              body { margin: 0; padding: 10px; }
            </style>
          </head>
          <body>
            ${divContents}
          </body>
        </html>
      `)
      doc.close()
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.onafterprint = () => {
          document.body.removeChild(iframe)
          handleClose()
        }
        iframe.contentWindow.print()
      }
    }

    const timeout = setTimeout(() => {
      handlePrint()
    }, 1000)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <MuiModal open={true} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" sx={{ overflow: 'scroll' }}>
      <Box
        sx={{ ...ticketStyle, left: `calc(50% - ${TicketDimension[1] / 2}mm)`, padding: '0', margin: '10px' }}
        id="stickersPrintBox"
        style={{
          width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
          height: `${TicketDimension ? TicketDimension[0] * qrListToPrint.length : ''}mm`,
        }}
      >
        <style>
          {`
            @media print {
              .page-break {
                page-break-before: always;
                break-before: page;
                visibility: visible;
              }
            }
            @page {
              margin: 0;
              width: '${TicketDimension ? +TicketDimension[1] + 5 : ''}mm';
              size: auto;
            }
          `}
        </style>
        {qrListToPrint.map((qrData, index) => {
          return (
            <React.Fragment key={`${index}qrkey`}>
              <Box
                className="printable"
                style={{
                  width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
                  height: `${TicketDimension ? TicketDimension[0] : ''}mm`,
                  fontFamily: FormatFont
                    ? `${FormatFont},Arial,Helvetica,"Segoe UI",Roboto,sans-serif`
                    : 'Microsoft Sans Serif", Arial,Helvetica,"Segoe UI",Roboto, sans-serif',
                  position: 'relative',
                }}
              >
                {visibleTicketFormat?.map((item, i) => {
                  return <TicketLine key={`${i}ticketpreviewkey`} item={item} index={i} TicketData={TicketData} />
                })}
                {visibleQrAndLogoFormat?.map((item, i) => {
                  return <QrCode key={`${i}qriptemKey`} item={item} index={i} qrValue={qrData.data} qrNo={qrData.index} LogoURL={LogoURL} />
                })}
              </Box>
              {index < qrListToPrint.length - 1 && <div class="page-break"></div>}
            </React.Fragment>
          )
        })}
      </Box>
    </MuiModal>
  )
}
export const successPopUpKeyDown = (e, nextRef) => {
  const ListeningKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']
  if (ListeningKeys.includes(e.key)) {
    e.preventDefault()
    nextRef.current.focus()
  }
}
export const BookingPrintPreview = (data) => {
  const { TicketDimension, TicketFormat, TicketData, QRandLogoFormat, FormatFont, intUserID } = {
    ...data,
  }
  const splitters = TicketFormat.find((item) => item.includes('--THERMAL-PRINT-SPLITTER--'))
  const hasMultiPage = !!splitters
  let [firstPage, secondPage] = [TicketFormat, []]
  if (splitters) {
    ;[firstPage, secondPage] = TicketFormat.reduce(
      ([p, f], e) => (e.split('|')[3] < +splitters.split('|')[3] ? [[...p, e], f] : [p, [...f, e]]),
      [[], []]
    )
  }
  firstPage = filterItemsHiddenByTables(firstPage, TicketFormat)
  secondPage = filterItemsHiddenByTables(secondPage, TicketFormat)
  const visibleQrAndLogoFormat = filterQrLogoHiddenByTables(QRandLogoFormat, TicketFormat)
  const { LogoURL } = { ...TicketData }
  const ticketParams = {
    BookingID: TicketData['BookingID'],
    intUserID: intUserID,
  }
  const LrDetailUrl = getTrackingUrl.call(ticketParams)
  const [showPopUpPrint, setShowPopPrint] = useState(true)
  const handleClose = () => {
    setShowPopPrint(false)
    data.onClose && data.onClose()
  }
  useEffect(() => {
    const handlePrint = () => {
      if (hasMultiPage) {
        document.getElementById('TSUP').click()
      } else {
        const divContents = document.getElementById('printBox')?.innerHTML
        if (!divContents) return
        const iframe = document.createElement('iframe')
        iframe.style.position = 'fixed'
        iframe.style.right = '0'
        iframe.style.bottom = '0'
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = '0'
        document.body.appendChild(iframe)

        const doc = iframe.contentDocument || iframe.contentWindow.document
        doc.open()
        doc.write(`
          <html>
            <head>
              <style>
                body { margin: 0; padding: 10px; }
              </style>
            </head>
            <body>
              ${divContents}
            </body>
          </html>
        `)
        doc.close()
        iframe.onload = () => {
          iframe.contentWindow.focus()
          iframe.contentWindow.onafterprint = () => {
            document.body.removeChild(iframe)
            handleClose()
          }
          iframe.contentWindow.print()
        }
      }
    }
    setTimeout(() => {
      handlePrint()
    }, 1000)
    window.onafterprint = () => {
      handleClose()
    }
  }, [])

  const TSUP = () => {
    var divContents = document.getElementById('first-page-print')?.innerHTML
    var divContents1 = document.getElementById('second-page-print')?.innerHTML

    // Create a hidden iframe for printing the first page
    var iframe1 = document.createElement('iframe')
    iframe1.style.display = 'none'
    document.body.appendChild(iframe1)
    iframe1.contentDocument.write(divContents)
    iframe1.contentDocument.close()
    iframe1.contentWindow.print()
    document.body.removeChild(iframe1)

    if (divContents1) {
      // Create a hidden iframe for printing the second page
      var iframe2 = document.createElement('iframe')
      iframe2.style.display = 'none'
      document.body.appendChild(iframe2)
      iframe2.contentDocument.write(divContents1)
      iframe2.contentDocument.close()
      iframe2.contentWindow.print()
      document.body.removeChild(iframe2)
    }

    handleClose()
  }

  // const TSUP = () => {
  //   var divContents = document.getElementById('first-page-print')?.innerHTML
  //   var divContents1 = document.getElementById('second-page-print')?.innerHTML
  //   var a = window.open('', '', '')
  //   a.document.write(divContents)
  //   a.print()
  //   a.close()
  //   if (divContents1) {
  //     var b = window.open('', '', '')
  //     b.document.write(divContents1)
  //     b.print()
  //     b.close()
  //   }
  //   handleClose()
  // }
  return (
    <MuiModal
      open={showPopUpPrint}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ overflow: 'scroll' }}
    >
      <Box
        sx={{ ...ticketStyle, left: `calc(50% - ${TicketDimension[1] / 2}mm)`, padding: '0', margin: '10px' }}
        id="printBox"
        style={{
          width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
          height: `${TicketDimension ? TicketDimension[0] : ''}mm`,
        }}
      >
        <style>
          {`
          @page {
            margin: 0;
            width: '${TicketDimension ? +TicketDimension[1] + 5 : ''}mm';
            size: auto;
          }
        `}
        </style>
        <Box
          className="printable"
          style={{
            width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
            height: `${TicketDimension ? TicketDimension[0] : ''}mm`,
            fontFamily: FormatFont
              ? `${FormatFont},Arial,Helvetica,"Segoe UI",Roboto,sans-serif`
              : 'Microsoft Sans Serif", Arial,Helvetica,"Segoe UI",Roboto, sans-serif',
          }}
        >
          <div
            id="first-page-print"
            style={{
              height: hasMultiPage ? `${splitters.split('|')[3]}px` : undefined,
              width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
              fontFamily: `Arial,Helvetica,"Segoe UI",Roboto,sans-serif`,
              whiteSpace: 'nowrap',
              color: '#000',
            }}
          >
            <div
              style={{
                height: hasMultiPage ? `${splitters.split('|')[3]}px` : undefined,
                width: `${TicketDimension ? TicketDimension[1] : ''}mm`,
              }}
            >
              {firstPage?.map((item, i) => {
                return <TicketLine key={`${i}ticketpreviewkey`} item={item} index={i} TicketData={TicketData} />
              })}
            </div>
          </div>
          <div
            id="second-page-print"
            style={{
              height: hasMultiPage ? `calc(${TicketDimension[0]}mm - ${splitters.split('|')[3]}px)` : undefined,
              width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
              position: 'relative',
              fontFamily: `Arial,Helvetica,"Segoe UI",Roboto,sans-serif`,
              whiteSpace: 'nowrap',
              color: '#000',
            }}
          >
            <div
              style={{
                height: hasMultiPage ? `calc(${TicketDimension[0]}mm - ${splitters.split('|')[3]}px)` : undefined,
                width: `${TicketDimension ? +TicketDimension[1] + 5 : ''}mm`,
                position: 'relative',
              }}
            >
              {secondPage?.map((item, i) => {
                return (
                  <TicketLine
                    key={`${i}ticketpreviewkey`}
                    item={item}
                    index={i}
                    TicketData={TicketData}
                    topDeduct={+splitters.split('|')[3]}
                  />
                )
              })}
            </div>
          </div>
          {visibleQrAndLogoFormat?.map((item, i) => {
            return <QrCode key={`${i}qritemKey`} item={item} index={i} qrValue={LrDetailUrl} LogoURL={LogoURL} />
          })}
        </Box>
        <Button id="TSUP" onClick={() => TSUP()} style={{ visibility: 'hidden' }}>
          TSUP
        </Button>
      </Box>
    </MuiModal>
  )
}
export const TicketLine = (props) => {
  const { item, index, TicketData, topDeduct } = { ...props }
  const loginData = useSelector((state) => state?.common?.loginData)
  const { intCompanyID } = loginData
  if (!item || item.includes('--THERMAL-PRINT-SPLITTER--')) return null
  if (isTableToken(item)) {
    const tableItem = decodeTable(item)
    const topPos = (tableItem.top || 0) - (topDeduct || 0)
    const tableWidth =
      (tableItem.columnWidths || []).reduce((sum, width) => sum + width, 0) ||
      (tableItem.cols || 0) * (tableItem.cellWidth || 0)
    return (
      <table
        key={index + 'tablekey'}
        style={{
          position: 'absolute',
          left: `calc(${getNum(tableItem.left) + 10}px + 2.5mm)`,
          top: `${topPos}px`,
          width: `${tableWidth}px`,
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          color: '#000',
          fontFamily: `Arial,Helvetica,"Segoe UI",Roboto,sans-serif`,
        }}
      >
        <tbody>
          {(tableItem.cells || []).map((row, ri) => (
            <tr key={ri}>
              {(row || []).map((cell, ci) => (
                <td
                  key={ci}
                  style={{
                    height: `${(tableItem.rowHeights && tableItem.rowHeights[ri]) || tableItem.cellHeight}px`,
                    maxHeight: `${(tableItem.rowHeights && tableItem.rowHeights[ri]) || tableItem.cellHeight}px`,
                    width: `${(tableItem.columnWidths && tableItem.columnWidths[ci]) || tableItem.cellWidth}px`,
                    border: '1px solid #000',
                    padding: 0,
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    color: '#000',
                    verticalAlign: 'top',
                  }}
                >
                  <div
                    style={{
                      height: `${(tableItem.rowHeights && tableItem.rowHeights[ri]) || tableItem.cellHeight}px`,
                      maxHeight: `${(tableItem.rowHeights && tableItem.rowHeights[ri]) || tableItem.cellHeight}px`,
                      overflow: 'hidden',
                      padding: '2px',
                      boxSizing: 'border-box',
                      fontSize: `${getNum(tableItem.font)}pt`,
                      fontWeight: cell.isBold ? 'bold' : 'normal',
                      fontStyle: cell.isItalic ? 'italic' : 'normal',
                      textDecoration: cell.isUnderline ? 'underline' : 'none',
                      textAlign: cell.alignment || 'left',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                  >
                    {resolveCellDisplayValue(cell.content, TicketData)}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
  let [something, value, left, top, fontSize, v, fontWeight] = item.split('|')
  // if (v === 'V') {
  //   console.log(value, TicketData[value?.replace('@@', '').replace('@', '')])
  // } else {
  //   console.log(value)
  // }
  if (topDeduct) {
    top = top - topDeduct
  }
  return v === 'V' ? (
    <span
      key={index + 'linekey'}
      style={{
        position: 'absolute',
        fontSize: `${getNum(fontSize)}pt`,
        left: `calc(${getNum(left) + 10}px + 2.5mm)`,
        top: `${top}px`,
        fontWeight: fontWeight == 1 ? 'bold' : '',
        color: '#000',
        fontFamily: `Arial,Helvetica,"Segoe UI",Roboto,sans-serif`,
        whiteSpace: 'pre-line',
      }}
    >
      {
        (intCompanyID === GOLINK || intCompanyID === SS_CARRIERS)
          ? (
            value === '@@ListOfConsigns@' ||
            value === '@@RT@' ||
            value === '@@Items@' ||
            value === '@@Freight@' ||
            value === '@@ItemType@' ||
            value === '@@NoA@'
          )
            ? TicketData[value?.replaceAll('@', '')]?.split(',').join('\n')
            : TicketData[value?.replaceAll('@', '')]
          : TicketData[value?.replaceAll('@', '')]
      }
    </span>
  ) : (
    <span
      key={index + 'linekey'}
      style={{
        position: 'absolute',
        fontSize: `${getNum(fontSize)}pt`,
        left: `calc(${getNum(left) + 10}px + 2.5mm)`,
        top: `${top}px`,
        fontWeight: fontWeight == 1 ? 'bold' : '',
        color: '#000',
        fontFamily: `Arial,Helvetica,"Segoe UI",Roboto,sans-serif`,
        whiteSpace: 'normal',
      }}
    >
      {value}
    </span>
  )
}
export const getpt = (pxvalue) => {
  return (getNum(pxvalue) * 72) / 96
}
export const QrCode = (props) => {
  const { item, qrValue, LogoURL, qrNo } = { ...props }
  const [printType, left, top, height, width] = item.split('|')
  return printType === 'QR' ? (
    <React.Fragment>
      <QRCode
        size={256}
        style={{
          position: 'absolute',
          left: `${left}px`,
          top: `${top}px`,
          height: `${height}px`,
          width: `${width}px`,
        }}
        value={qrValue}
        viewBox={`0 0 256 256`}
      />
      {qrNo ? (
        <span
          style={{
            position: 'absolute',
            left: `${left}px`,
            top: `${+top + +height + 2}px`,
            height: `16px`,
            width: `${width}px`,
            fontSize: '15pt',
            color: '#000',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          No:{qrNo}
        </span>
      ) : (
        ''
      )}
    </React.Fragment>
  ) : printType === 'Logo' ? (
    <img
      style={{
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        height: `${height}px`,
        width: `${width}px`,
      }}
      src={LogoURL}
    />
  ) : (
    ''
  )
}
const ticketStyle = {
  position: 'relative',
  left: '50%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
}

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '0',
  textAlign: 'left',
  color: theme.palette.text.secondary,
  boxShadow: 'none',
}))

export const TableUI = styled(Table)({
  // minWidth: 650,
  '& .MuiTableCell-root': {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
  },
})
export const requiredLabelTxt = (label, required = true) => {
  if (!required) return label;

  return (
    <span>
      {label}
      <span style={{ color: 'red', paddingLeft: 5 }}>*</span>
    </span>
  );
};

export const SingleInputModal = (props) => {
  const { data, functions } = props
  const { headTxt, inputId, inputLabel, inputName, inputType, inputValue, mainButtonLabel, mainButtonId, instructionText } = data
  const { updateModal, onChangeInput, onClickButton, inputFilter, onCloseCallback } = functions
  let { onKeyDown } = functions
  if (!onKeyDown) {
    onKeyDown = (e) => {
      singleInputKeyDown(e, mainButtonId, updateModal)
    }
  }
  useEffect(() => {
    focusElemnt(inputId)
  }, [])
  return (
    <Modal headTxt={headTxt} width={'25%'} updateModal={updateModal} onCloseCallback={onCloseCallback}>
      <Stack>
        {instructionText ? (
          <Box sx={{ px: '12px', pt: '16px' }}>
            <Typography sx={{ fontSize: '14px', color: '#2f2f2f' }}>{instructionText}</Typography>
          </Box>
        ) : null}
        <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
          <div className={'input--wrapper'} style={{ width: '100%', marginLeft: '12px', marginRight: '8px', marginTop: '15px' }}>
            <LineInputV2
              width="11%"
              id={inputId}
              name={inputName}
              label={inputLabel}
              value={inputValue}
              filter={inputFilter}
              onKeyDown={onKeyDown}
              maxLength={props.maxLength}
              type={inputType || 'number'}
              onBlur={(e) => {
                onChangeInput(e.target.value)
              }}
            />
          </div>
        </Box>
      </Stack>
      <Stack>
        <div>
          <Box style={{ margin: '15px 0px', marginLeft: '12px', marginRight: '8px' }}>
            <Button
              variant="contained"
              style={{ backgroundColor: '#ff0000', width: '100%', padding: '10px', fontSize: '13px' }}
              onClick={onClickButton}
              id={mainButtonId}
            >
              {mainButtonLabel || 'Save'}
            </Button>
          </Box>
        </div>
      </Stack>
    </Modal>
  )
}
export const SingleInputModal2 = (props) => {
  const { data, functions } = props
  const { headTxt, inputId, inputLabel, inputName, inputType, inputValue, mainButtonLabel, mainButtonId } = data
  const { updateModal, onChangeInput, onClickButton, inputFilter, onCloseCallback } = functions
  let { onKeyDown } = functions
  if (!onKeyDown) {
    onKeyDown = (e) => {
      singleInputKeyDown(e, mainButtonId, updateModal)
    }
  }
  useEffect(() => {
    focusElemnt(inputId)
  }, [])
  return (
    <Modal headTxt={headTxt} width={'25%'} updateModal={updateModal} onCloseCallback={onCloseCallback}>
      <Stack>
        <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
          <div className={'input--wrapper'} style={{ width: '100%', marginLeft: '12px', marginRight: '8px', marginTop: '15px' }}>
            <Lineinput
              width="11%"
              id={inputId}
              name={inputName}
              label={inputLabel}
              value={inputValue}
              filter={inputFilter}
              onKeyDown={onKeyDown}
              type={inputType || 'number'}
              onChange={(e) => {
                onChangeInput(e.target.value)
              }}
            />
          </div>
        </Box>
      </Stack>
      <Stack>
        <div>
          <Box style={{ margin: '15px 0px', marginLeft: '12px', marginRight: '8px' }}>
            <Button
              variant="contained"
              style={{ backgroundColor: '#ff0000', width: '100%', padding: '10px', fontSize: '13px' }}
              onClick={onClickButton}
              id={mainButtonId}
            >
              {mainButtonLabel || 'Save'}
            </Button>
          </Box>
        </div>
      </Stack>
    </Modal>
  )
}
export const GstnValidationUI = ({ gstnValidationData, saveGSTN, updateModal }) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const de = translations.delivery
  const gst = gstnValidationData
  const gstd = gst.data
  const buttonRef = useRef(null)
  useEffect(() => {
    buttonRef.current.focus()
  }, [])
  return (
    <Modal
      headTxt={`GSTIN Status`}
      width={'30%'}
      updateModal={() => {
        updateModal()
      }}
    >
      <Stack direction="column" sx={{ padding: '15px 0px' }} className="booking-confirmation-section">
        <Box sx={{ width: '100%', padding: '12px 15px' }} className="sender-receiver">
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {cs.GSTN}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gst?.GSTN}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {cs.companyName}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd?.CompanyName}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {de.tradeName}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd?.Tradename}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
             {de.address}
            </Typography>
            :
            <Typography className="sr-value" style={{ alignItems: 'left', whiteSpace: 'initial' }}>
              {getGSTNAddress(gstd, cs)}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {de.status}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd.Status}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '100%', padding: '12px 15px' }}>
          <Button
            ref={buttonRef}
            variant="contained"
            className="btn btn-primary"
            onClick={(e) => {
              saveGSTN(gst)
              updateModal()
            }}
            sx={{
              width: '100%',
            }}
          >
            {cs.ok}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
export const CameraUi = (data) => {
  const { translations } = useTranslation()
  const bs = translations.booking
  const { updateModal, captureCallback } = data
  const videoRef = useRef(null)
  let videoStream = null // Declare a variable to store the video stream
  const handleCameraAccess = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        const videoElement = videoRef.current
        if (videoElement) {
          videoElement.srcObject = stream
          videoElement.play()
          videoStream = stream
        }
      })
      .catch((error) => {
        console.error(bs.errorAccessingCamera, error)
      })
  }
  const stopCameraAccess = () => {
    if (videoStream) {
      const tracks = videoStream.getTracks()
      tracks.forEach((track) => {
        track.stop() // Stop each track in the video stream
      })
      videoStream = null // Clear the video stream variable
    }
  }
  const handleCapture = () => {
    const videoElement = videoRef.current

    if (videoElement && videoElement.srcObject) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')

      // Set canvas dimensions to match the video element
      canvas.width = videoElement.videoWidth
      canvas.height = videoElement.videoHeight

      // Draw the current video frame onto the canvas
      context.drawImage(videoElement, 0, 0, videoElement.videoWidth, videoElement.videoHeight)

      // Convert the canvas content to a data URL
      const dataUrl = canvas.toDataURL('image/jpeg')

      // Convert data URL to Blob
      stopCameraAccess()
      const file = dataURLtoFile(dataUrl, 'image.jpg')
      captureCallback(file)
    }
  }
  const dataURLtoFile = (dataURL, filename) => {
    const arr = dataURL.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }
  useEffect(() => {
    setTimeout(() => {
      focusElemnt('camerabuttonOk')
    }, 0)
  })
  useEffect(() => {
    if (videoRef.current) {
      handleCameraAccess()
    }
  }, [videoRef])
  return (
    <Modal headTxt={data.data?.headTxt ? data.data?.headTxt : bs.camera} width={'50%'} updateModal={updateModal}>
      <Item className="flex-center-all">
        <video ref={videoRef} />
      </Item>
      <Item className="flex-center-all">
        <Button
          variant="contained"
          className="btn btn-primary"
          onClick={() => handleCapture()}
          id={'camerabuttonOk'}
          sx={{
            padding: '10px',
            letterSpacing: '2px',
          }}
        >
          {bs.captureImage}
        </Button>
      </Item>
    </Modal>
  )
}

export const ImageOptionPopup = (props) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const de = translations.delivery
  const { updateModal, data, onUploadClick, uploadLabel, onCaptureClick, captureLabel, DisablePhotoIDUpload } = props
  useEffect(() => {
    setTimeout(() => {
      focusElemnt('uploadChooseButton')
    }, 0)
  }, [])
  const handleUploadButton = (e, nextId, prevId) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      focusElemnt(nextId)
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      focusElemnt(prevId)
    }
    if (e.key === 'Escape') {
      updateModal()
      setTimeout(() => {
        focusElemnt(prevId)
      }, 0);
    }
  }
  return (
    <>
      <Modal headTxt={de.uploadOrCaptureImage} width={'30%'} updateModal={updateModal} onCloseCallback={() => { }}>
        <Stack direction="column" sx={{ padding: '15px' }}>
          <Button
            id={data?.uploadId || 'uploadChooseButton'}
            style={{
              width: '100%',
              border: '0.2em dotted #0086ff',
              color: '#0086ff',
              fontWeight: 'bold',
              borderRadius: '4px',
              textAlign: 'center',
              padding: '6px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              height: 'auto',
              fontSize: '16px',
            }}
            disabled={DisablePhotoIDUpload === 1 ? true : false}
            onClick={onUploadClick}
            onKeyDown={(e) => handleUploadButton(e, data?.uploadId || 'captureCameraButton', iid.imageUploadcontrol)}
          >
            <>
              <span style={{ marginRight: '12px' }}>
                <DriveFolderUploadIcon style={{ color: '#0086ff' }} />
              </span>
              {uploadLabel || de.uploadImage}
            </>
          </Button>
          <Button
            id={data?.uploadId || 'captureCameraButton'}
            style={{
              width: '100%',
              border: '0.2em dotted #0086ff',
              color: '#0086ff',
              fontWeight: 'bold',
              borderRadius: '4px',
              textAlign: 'center',
              padding: '6px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              height: 'auto',
              marginTop: '10px',
              fontSize: '16px',
            }}
            onClick={onCaptureClick}
            onKeyDown={(e) => handleUploadButton(e, data?.uploadId || 'cancelImageUpload', data?.uploadId || 'uploadChooseButton')}
          >
            <>
              <span style={{ marginRight: '12px' }}>
                <PhotoCameraIcon style={{ color: '#0086ff' }} />
              </span>
              {captureLabel || de.captureImage}
            </>
          </Button>
          <Button
            id="cancelImageUpload"
            variant="contained"
            className="btn btn-primary"
            onClick={() => {
              updateModal()
              setTimeout(() => {
                focusElemnt('VehicleNumberIn')
              }, 0)
              // focusElemnt("Extra_Hamali")
            }}
            sx={{
              width: '100%',
              letterSpacing: '2px',
              marginTop: '10px',
            }}
            onKeyDown={(e) => handleUploadButton(e, data?.uploadId || 'uploadChooseButton', data?.uploadId || 'captureCameraButton')}
          >
            {cs.cancel}
          </Button>
        </Stack>
      </Modal>
    </>
  )
}
export const ImagePreiewPopup = (props) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const de = translations.delivery
  const { data, updateModal, onSave } = props
  useEffect(() => {
    setTimeout(() => {
      focusElemnt('imagePreviewSave')
    }, 0)
  }, [])
  return (
    <Modal headTxt={data?.headTxt || de.imagePreview} width={'30%'} updateModal={updateModal}>
      <Stack direction="column" sx={{ padding: '15px' }}>
        <Box
          sx={{
            width: '100%',
            position: 'relative',
          }}
          className="flex-center-all"
        >
          <img
            style={{
              maxHeight: '100%',
              maxWidth: '100%',
            }}
            src={data?.src}
          />
        </Box>
        {!data?.hideControl && (
          <Box sx={{ width: '100%', margin: '12px 0px' }}>
            <Button
              variant="contained"
              id={'imagePreviewSave'}
              onClick={() => onSave()}
              className="btn btn-primary"
              sx={{
                width: '100%',
                padding: '10px',
                letterSpacing: '2px',
              }}
            >
              {cs.save}
            </Button>
          </Box>
        )}
      </Stack>
    </Modal>
  )
}

export const IdAndImagePreview = (props) => {
  const { headTxt, idTypeLabel, idTypeValue, idLabel, idValue, imgUrl, updateModal } = props
  return (
    <Modal headTxt={headTxt || 'Preview'} width={'30%'} updateModal={updateModal}>
      <Stack direction="column" sx={{ padding: '15px' }}>
        <Item sx={{ width: '100%' }}>
          <DropDown defaultvalue={idTypeValue} value={idTypeValue} label={idTypeLabel || `ID Type`} data={[]} width="100%" disabled />
        </Item>
        <Item sx={{ width: '100%' }} className={'input--wrapper'}>
          <LineInputV2 label={idLabel || `ID Number`} type="text" value={idValue} upperCase={true} disabled />
        </Item>
        <Item sx={{ width: '100%' }}>
          <Box
            sx={{
              width: '100%',
              position: 'relative',
            }}
            className="flex-center-all"
          >
            <img
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
              }}
              src={imgUrl || noImageUrl}
            />
          </Box>
        </Item>
      </Stack>
    </Modal>
  )
}

export const IdProofModalUI = React.memo((props) => {
  const { translations } = useTranslation()
  const cs = translations?.common || {}
  const de = translations?.delivery || {}
  const { data, methods } = props
  const [delRes, setDelRes] = useAtom(deliveryDataAtom)
  const [idFile, setIdFile] = useAtom(deliveryIdFileAtom)
  const [, setAlert] = useAtom(alertAtom)
  const { headTxt, idProofList, Lbl, focusedItem, DisablePhotoIDUpload } = data
  const { onSave, updateModal } = methods
  const [openCamera, setOpenCamera] = useState(false)
  const [autoFocus, setAutoFocues] = useState(focusedItem || 1)
  const firstButtonRef = useRef(null)
  const focusList = ['', iid.senderIdtype, iid.senIdProof, iid.sendIdpreview, iid.sendIdCameraButton]

  useEffect(() => {
    if (firstButtonRef && firstButtonRef.current) {
      focusElemnt(focusList[autoFocus])
    }
  }, [firstButtonRef, autoFocus])
  const captureCallback = (file) => {
    setOpenCamera(false)
    setIdFile(file)
    focusElemnt(iid.senderIdSave)
  }
  function keyDownIdType(e) {
    if (['Escape', 'Enter'].includes(e.key)) {
      e.preventDefault()
      if (e.key === 'Escape') {
        updateModal()
        setTimeout(() => {
          focusElemnt(iid.senderIdControl)
        }, 0)
      }
      if (e.key === 'Enter') {
        focusElemnt(iid.senIdProof)
      }
    }
  }
  const keyDownIdNumber = (e) => {
    if (['Escape', 'Enter', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
      e.preventDefault()
      if (['Escape', 'ArrowUp'].includes(e.key)) setAutoFocues(1)
      if (['Enter', 'ArrowDown'].includes(e.key)) setAutoFocues(3)
    }
  }
  const valdiateIDNumber = (val, idType) => {
    if (idType === 'Aadhar Card') {
      return validateAadhar(val)
    }
    if (idType === 'PAN Card') {
      return validatePan(val)
    }
    if (idType === 'Driving Licence') {
      return validateDL(val)
    }
    return false
  }
  return (
    <>
      <Modal headTxt={headTxt || de.idProof} width={'35%'} updateModal={updateModal} onCloseCallback={() => { }}>
        <Stack direction="column" sx={{ padding: '15px' }}>
          <Item sx={{ width: '100%' }}>
            {/* confirm */}
            <DropDownOA
              id={iid.senderIdtype}
              defaultvalue={delRes?.RecIDProof || ""}
              value={delRes?.RecIDProof || ""}
              label={de.idTypeLabel.replace('{{label}}', Lbl)}
              onSelect={(id) => {
                setDelRes((prev) => ({
                  ...prev,
                  RecIDProof: id.IDProof,
                  RecIDProofid: id.IDProofid,
                }))
                setAutoFocues(2)
              }}
              data={idProofList}
              dataKey={`IDProof`}
              idKey={`IDProofid`}
              width="100%"
              searchPlaceholder={de.searchIDType}
              nextId={iid.senIdProof}
              prevId="sender-tab-0"
              onKeyDown={keyDownIdType}
              autoFocus={autoFocus === 1}
            />
          </Item>
          <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ margin: '2px 8px', width: '100%' }}>
              <LineInputV2
                id={iid.senIdProof}
                label={de.enterIdNumberLabel.replace('{{label}}', Lbl)}
                width="11%"
                type="text"
                name={props.modalType ? 'recIdProof' : 'senIdProof'}
                value={delRes?.idNumber || ""}
                filter={getFilterWithIdType(delRes?.RecIDProof)}
                maxLength={getLengthWithIDType(delRes?.RecIDProof)}
                upperCase={true}
                onFocus={() => {
                  setAutoFocues(2)
                }}
                onBlur={(e) => {
                  if (e.target.value) {
                    if (valdiateIDNumber(e.target.value, delRes?.RecIDProof)) {
                      setDelRes((prev) => ({
                        ...prev,
                        idNumber: e.target.value,
                      }))
                    } else {
                      setAlert({ show: true, msg: de.invalidIdType.replace('{idType}', delRes?.RecIDProof || ''), nextId: 'senIdProof' })
                    }
                  }
                }}
                sx={{ width: '100%' }}
                autoFocus={autoFocus === 2}
                onKeyDown={keyDownIdNumber}
              />
            </div>
          </Box>
          <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ margin: '8px 8px', width: '100%' }}>
              <div
                style={{
                  marginBottom: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  {de.lblIdImage.replace('{{label}}', Lbl)}
                  {!idFile && <span style={{ fontSize: ' 12px' }}>{de.jpgImageSizeNote}</span>}
                </div>
              </div>
              <div>
                <input
                  style={{ display: 'none' }}
                  id="upload-photo-input"
                  name="upload-photo"
                  type="file"
                  accept=".jpg,.jpeg,image/jpeg"
                  onChange={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    const file = e.target.files?.[0]
                    if (!file) return
                    const isJpg = file.type === 'image/jpeg' && /\.(jpg|jpeg)$/i.test(file.name)
                    if (!isJpg) {
                      alert(de.onlyJpgImagesAreAllowed)
                      e.target.value = ''
                      return
                    }
                    setIdFile(file)
                  }}
                />
                {idFile ? (
                  <div
                    style={{
                      width: '100%',
                      height: '30vh',
                      border: '0.2em dotted #0086ff',
                      marginBottom: '10px',
                    }}
                  >
                    <img
                      style={{
                        height: '100%',
                        width: '100%',
                      }}
                      src={URL.createObjectURL(idFile)}
                    />
                  </div>
                ) : (
                  ''
                )}
                <Button
                  ref={firstButtonRef}
                  id={iid.sendIdpreview}
                  style={{
                    width: '100%',
                    border: '0.2em dotted #0086ff',
                    color: '#0086ff',
                    fontWeight: 'bold',
                    borderRadius: '4px',
                    textAlign: 'center',
                    padding: '6px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    height: 'auto',
                    fontSize: '16px',
                  }}
                  disabled={DisablePhotoIDUpload === 1 ? true : false}
                  onClick={(e) => document.getElementById('upload-photo-input').click()}
                  onKeyDown={(e) => handleUploadButton(e, iid.sendIdCameraButton, iid.senIdProof)}
                >
                  <>
                    <span style={{ marginRight: '12px' }}>
                      <DriveFolderUploadIcon style={{ color: '#0086ff' }} />
                    </span>{' '}
                    {de.uploadIdImageLabel.replace('{{label}}', Lbl)}
                  </>
                </Button>
                <Button
                  id={iid.sendIdCameraButton}
                  style={{
                    width: '100%',
                    border: '0.2em dotted #0086ff',
                    color: '#0086ff',
                    fontWeight: 'bold',
                    borderRadius: '4px',
                    textAlign: 'center',
                    padding: '6px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    height: 'auto',
                    marginTop: '10px',
                    fontSize: '16px',
                  }}
                  onClick={(e) => setOpenCamera(true)}
                  onKeyDown={(e) => handleUploadButton(e, iid.senderIdSave, iid.sendIdpreview)}
                >
                  <>
                    <span style={{ marginRight: '12px' }}>
                      <PhotoCameraIcon style={{ color: '#0086ff' }} />
                    </span>{' '}
                    {de.captureIdImageFromCameraLabel.replace('{{label}}', Lbl)}
                  </>
                </Button>
              </div>
              <div style={{ padding: '12px 0px', color: '#666' }}>{/* Drag images to adjust */}</div>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={onSave}
                sx={{
                  width: '100%',
                  padding: '10px',
                  letterSpacing: '2px',
                }}
                id={iid.senderIdSave}
                onKeyDown={(e) => handleIdSaveButton(e, 'recIdprooftwoi', iid.sendIdCameraButton)}
              >
                {cs.save}
              </Button>
            </div>
          </Box>
        </Stack>
      </Modal>
      {openCamera && <CameraUi captureCallback={captureCallback} updateModal={setOpenCamera} />}
    </>
  )
})
export const BookingIdProofModalUI = React.memo((props) => {
  const { data, methods } = props
  const [, setAlert] = useAtom(alertAtom)
  const {
    headTxt,
    idProofList,
    modal,
    Lbl = 'Sender',
    DisablePhotoIDUpload,
  } = data
  const {
    onIdTypeChange,
    onIdNumberChange,
    onFileChange,
    onSave,
    onClose,
  } = methods
  const [openCamera, setOpenCamera] = useState(false)
  const [autoFocus, setAutoFocues] = useState(1)
  const firstButtonRef = useRef(null)
  const focusList = [
    '',
    iid.senderIdtype,
    iid.senIdProof,
    iid.sendIdpreview,
    iid.sendIdCameraButton,
  ]
  const { translations } = useTranslation()
  const bs = translations.booking
  useEffect(() => {
    if (focusList[autoFocus]) {
      focusElemnt(focusList[autoFocus])
    }
  }, [autoFocus])
  const captureCallback = (file) => {
    setOpenCamera(false)
    onFileChange(file)
    focusElemnt(iid.senderIdSave)
  }
  const keyDownIdType = (e) => {
    if (['Escape', 'Enter'].includes(e.key)) {
      e.preventDefault()
      if (e.key === 'Escape') {
        onClose()
        focusElemnt(iid.senderIdControl)
      }
      if (e.key === 'Enter') {
        setAutoFocues(2)
      }
    }
  }
  const keyDownIdNumber = (e) => {
    if (['Escape', 'Enter', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
      e.preventDefault()
      if (['Escape', 'ArrowUp'].includes(e.key)) setAutoFocues(1)
      if (['Enter', 'ArrowDown'].includes(e.key)) setAutoFocues(3)
    }
  }
  const validateIDNumber = (val, idType) => {
    if (!val || !idType) return false
    if (idType === 'Aadhar Card') return validateAadhar(val)
    if (idType === 'PAN Card') return validatePan(val)
    if (idType === 'Driving Licence') return validateDL(val)
    return true
  }

  if (!modal) return null
  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (!file) return

    // Strict MIME check
    if (file.type !== 'image/jpeg') {
      alert('Only JPG/JPEG images are allowed.')
      e.target.value = '' // reset input
      return
    }
    onFileChange(file)
  }
  return (
    <>
      <Modal headTxt={headTxt || bs.idProof} width={'35%'} updateModal={onClose} onCloseCallback={onClose}>
        <Stack direction="column" sx={{ padding: '15px' }}>
          <Item sx={{ width: '100%' }}>
             <DropDownOA
              id={iid.senderIdtype}
              label={bs.senderIDType}
              defaultvalue={modal.IdProofType?.IDProof || ''}
              value={modal.IdProofType?.IDProof || ''}
              data={idProofList}
              dataKey="IDProof"
              idKey="IDProofid"
              width="100%"
              searchPlaceholder={bs.searchIDType}
              autoFocus={autoFocus === 1}
              nextId={iid.senIdProof}
              prevId="sender-tab-0"
              onKeyDown={keyDownIdType}
              onSelect={(id) => {
                onIdTypeChange(id)
                setAutoFocues(2)
                // onIdNumberChange('')
              }}
            />
          </Item>
          <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ margin: '2px 8px', width: '100%' }}>
              <LineInputV2
              id={iid.senIdProof}
              label={bs.enterSenderIDNumber}
              value={modal.IdProof || ''}
              type="text"
              upperCase={true}
              maxLength={getLengthWithIDType(modal.IdProofType?.IDProof)}
              filter={getFilterWithIdType(modal.IdProofType?.IDProof)}
              autoFocus={autoFocus === 2}
              onFocus={() => setAutoFocues(2)}
              onKeyDown={keyDownIdNumber}
              onBlur={(e) => {
                const val = e.target.value
                if (!val) return

                if (validateIDNumber(val, modal.IdProofType?.IDProof)) {
                  onIdNumberChange(val)
                } else {
                  setAlert({ show: true, msg: bs.invalidIdType.replace('{idType}', modal.IdProofType?.IDProof || ''), nextId: iid.senIdProof })
                }
              }}
              sx={{ width: '100%' }}
            />
            </div>
          </Box>
          <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ margin: '8px 8px', width: '100%' }}>
              <div
                style={{
                  marginBottom: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  {bs.SenderIDImage}
                  {!modal.IdProofFile && <span style={{ fontSize: ' 12px' }}>(Note: size must be less than 1MB)</span>}
                </div>
              </div>
              <div>
                <input
                  style={{ display: 'none' }}
                  id="upload-photo-input"
                  name="upload-photo"
                  type="file"
                  accept="image/jpeg"
                  onChange={handleFileChange}
                />
                {modal.IdProofFile ? (
                  <div
                    style={{
                      width: '100%',
                      height: '30vh',
                      border: '0.2em dotted #0086ff',
                      marginBottom: '10px',
                    }}
                  >
                    <img
                      style={{
                        height: '100%',
                        width: '100%',
                      }}
                      src={URL.createObjectURL(modal.IdProofFile)}
                    />
                  </div>
                ) : (
                  ''
                )}
                <Button
                  ref={firstButtonRef}
                  id={iid.sendIdpreview}
                  style={{
                    width: '100%',
                    border: '0.2em dotted #0086ff',
                    color: '#0086ff',
                    fontWeight: 'bold',
                    borderRadius: '4px',
                    textAlign: 'center',
                    padding: '6px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    height: 'auto',
                    fontSize: '16px',
                  }}
                  disabled={DisablePhotoIDUpload === 1 ? true : false}
                  onClick={(e) => document.getElementById('upload-photo-input').click()}
                  onKeyDown={(e) => handleUploadButton(e, iid.sendIdCameraButton, iid.senIdProof)}
                >
                  <>
                    <span style={{ marginRight: '12px' }}>
                      <DriveFolderUploadIcon style={{ color: '#0086ff' }} />
                    </span>{' '}
                    {bs.uploadSenderIDImage}
                  </>
                </Button>
                <Button
                  id={iid.sendIdCameraButton}
                  style={{
                    width: '100%',
                    border: '0.2em dotted #0086ff',
                    color: '#0086ff',
                    fontWeight: 'bold',
                    borderRadius: '4px',
                    textAlign: 'center',
                    padding: '6px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    height: 'auto',
                    marginTop: '10px',
                    fontSize: '16px',
                  }}
                  onClick={(e) => setOpenCamera(true)}
                  onKeyDown={(e) => handleUploadButton(e, iid.senderIdSave, iid.sendIdpreview)}
                >
                  <>
                    <span style={{ marginRight: '12px' }}>
                      <PhotoCameraIcon style={{ color: '#0086ff' }} />
                    </span>{' '}
                    {bs.captureSenderIdImageFromCamera}
                  </>
                </Button>
              </div>
              <div style={{ padding: '12px 0px', color: '#666' }}></div>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={onSave}
                sx={{
                  width: '100%',
                  padding: '10px',
                  letterSpacing: '2px',
                }}
                id={iid.senderIdSave}
                onKeyDown={(e) => handleIdSaveButton(e, 'recIdprooftwoi', iid.sendIdCameraButton)}
              >
                {bs.save}
              </Button>
            </div>
          </Box>
        </Stack>
      </Modal>
      {openCamera && <CameraUi captureCallback={captureCallback} updateModal={setOpenCamera} />}
    </>
  )
})
export const TableRowTrips = (props) => {
  const { data, functions, index } = props
  const { el, selectedTrip, radioRefs } = data
  const { setSelectedTrip, handleKeyDown, onCloseCallback } = functions
  return (
    <TableRow>
      <TableCell sx={{ fontSize: '14px', padding: '5px' }}>
        <Radio
          id={el.TripID + 'radio'}
          checked={selectedTrip?.TripID === el.TripID}
          onChange={() => setSelectedTrip(el)}
          name={`isCrossingRadio`}
          size={'medium'}
          ref={(radio) => (radioRefs.current[index] = radio)}
          onKeyDown={(e) => handleKeyDown(e, onCloseCallback)}
        />
      </TableCell>
      <TableCell sx={{ fontSize: '14px', padding: ' 5px' }}>{el.TripName}</TableCell>
      <TableCell sx={{ fontSize: '14px', padding: ' 5px' }}>{formatDate2(el.ChartDate)}</TableCell>
      <TableCell sx={{ fontSize: '14px', padding: ' 5px' }}>{el.DriverName1}</TableCell>
      <TableCell sx={{ fontSize: '14px', padding: ' 5px' }}>{el.DriverContactNo1}</TableCell>
    </TableRow>
  )
}
